import axios from 'axios';

let Password : any = {};
Password.submitForm = async (data:any) =>{
    return await axios.post(`${process.env.REACT_APP_BASE_URL}/api/password/forget`, data)
}

export default Password;